export default function (err) {
    throw err;
}